let _paymentUrls = [];
const observablePaymentUrls = new Rx.BehaviorSubject(_paymentUrls);

/**
 * @ngdoc service
 * @name repositories.PaymentUrlsRepository
 *
 * @description
 * PaymentUrlsRepository.
 */
const PaymentUrlsRepository = {

    replace(data) {

        _paymentUrls = data;
        observablePaymentUrls.onNext(_paymentUrls);

    },

    getAll() {

        return _paymentUrls;

    },

    getObservable() {

        return observablePaymentUrls;

    },

};

export default PaymentUrlsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.paymentUrlsRepository.js